import { useEffect, useState } from "react";
import { api, PAGE_TEXT_DEFAULTS } from "@/lib/api";

export default function usePageTexts() {
  const [texts, setTexts] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setTexts(r.data.page_texts || {})).catch(() => {});
  }, []);
  return (k) => texts[k] || PAGE_TEXT_DEFAULTS[k];
}
